import { Component, OnInit } from '@angular/core';
import { FilteredListConfig, FilteredListItem, Badge } from '@appcatalyst/ng-cms-core-lib';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { ActivatedRoute, Router } from '@angular/router';
import { SpecialtiesService } from 'src/app/cms/specialties/specialties.service';
import { InsurancesService } from 'src/app/cms/insurances/insurances.service';
import { GroupsService } from '../groups/groups.service';
import { CitiesService } from '../cities/cities.service';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.scss'],
  providers: [FilteredListConfig]
})
export class FacilitiesComponent implements OnInit {
  private facilities: any[]
  facilitiesForm: FormGroup
  groups$: Observable<any>
  selectedRecordType: string
  coordinates: Coordinates
  showIndicator: boolean
  params: any
  showAdvanced = false
  specialties$: Observable<any[]>
  insurances$: Observable<any[]>
  cities$: Observable<any[]>
  
  constructor(
    private config: FilteredListConfig,
    private gs: GroupsService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private ss: SpecialtiesService,
    private is: InsurancesService,
    private cs: CitiesService
  ) { }

  ngOnInit() {
    this.groups$ = this.gs.getGroups()
    this.route.params.subscribe(params => {
      this.params = {...params}
      this.createForm()
    })
    this.route.data.subscribe((data: {facilities: any}) => {
      this.showIndicator = false
      this.facilities = data.facilities.data
      this.config.listItems = this.facilities.map(facility => {
        let badges: Badge[] = [
          {
            text: facility.id,
            className: 'badge-info'
          }
        ]
        return {
          _id: facility.id,
          title: facility.title || facility.short_title || facility.zip,
          description: facility.distance ? facility.distance + ' miles' : '',
          badge: badges
        }
      });
      this.config.count = data.facilities.count
      this.config.page = data.facilities.page
      this.config.limit = data.facilities.limit
      this.config.emitChanges()
    })
    this.specialties$ = this.ss.getSpecialtiesPicker()
    this.insurances$ = this.is.getinsurancesPicker()
    this.cities$ = this.cs.getCitiesPicker()
    this.config.title = 'Facilities'
    this.config.listItemClicked = this.facilitieselected
  }

  onChanges(): void {
    this.useLocation.valueChanges.subscribe(useLocation => {
      if (useLocation) {
        this.showIndicator = true
        this.addGeolocationParamsAndNavigate(this.params)
      } else {
        delete this.params.geolocation
        delete this.params.lat
        delete this.params.lon
        this.router.navigate([this.params], {relativeTo: this.route})
      }
    })
    this.insurance.valueChanges.subscribe(val => {
      this.updateParam('insurance', val)
    })
    this.specialty.valueChanges.subscribe(val => {
      this.updateParam('specialty', val)
    })
    this.city.valueChanges.subscribe(val => {
      this.updateParam('city', val)
    })

  }

  updateParam(param: string, val: string) {
    if (!val) delete this.params[param]
    else this.params[param] = val
    this.router.navigate([this.params], {relativeTo: this.route})
  }

  addGeolocationParamsAndNavigate(params: any) {
    if (!navigator.geolocation){
      return alert('Location not available');
    }
    navigator.geolocation.getCurrentPosition((position) => {
      params.lat = position.coords.latitude
      params.lon = position.coords.longitude
      params.geolocation = true
      this.router.navigate([params], {relativeTo: this.route})
    }) 
  }

  createForm = () => {
    this.facilitiesForm = this.fb.group({
      useLocation: [this.params.geolocation],
      specialty: [this.params.specialty || ''],
      insurance: [this.params.insurance || ''],
      city: [this.params.city || '']
    })
    this.onChanges()
  }

  facilitieselected = (id: string) => {
    this.router.navigate([id], { relativeTo: this.route })
  }

  get useLocation() { return this.facilitiesForm.get('useLocation') }
  get specialty() { return this.facilitiesForm.get('specialty') }
  get insurance() { return this.facilitiesForm.get('insurance') }
  get city() { return this.facilitiesForm.get('city') }
}
